'use strict';
const angular = require('angular');

/*@ngInject*/
export function VendorService($resource) {
  return $resource('/api/vendors/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/vendors/:id/attachments"
    }
  });
}


export default angular.module('conduu.VendorService', [])
  .factory('VendorService', VendorService)
  .name;



// WEBPACK FOOTER //
// ./client/components/vendors/vendors.service.js